import { Text } from 'bold-ui'
import { EvolucaoProblema, Problema } from 'view/atendimentos/detail/soap/aside/types/ProblemaModel'

import { MainDetailAccordion } from '../../main-detail-accordion/MainDetailAccordion'
import { BodyProblemaModal } from './BodyProblemaModal'
import { HeaderProblemaModal } from './HeaderProblemaModal'

interface AccordionProblemasModalProps {
  problemas: Problema[]
  filtro?: string
  noResultMessage?: string
  prontuarioId: string
}

export function AccordionProblemasModal(props: AccordionProblemasModalProps) {
  const { problemas, filtro, noResultMessage, prontuarioId } = props

  return (
    <>
      {problemas?.isNotEmpty() ? (
        <MainDetailAccordion<EvolucaoProblema, Problema>
          items={problemas}
          renderHeader={(renderProps) => (
            <HeaderProblemaModal highlight={filtro} prontuarioId={prontuarioId} {...renderProps} />
          )}
          renderDetailBody={BodyProblemaModal}
        />
      ) : (
        <Text component='p'>{noResultMessage}</Text>
      )}
    </>
  )
}
